import _ from 'lodash';

const langMap = require('./i18_map.json');

export default () => (lang) => {
  const key = _.findKey(langMap, (value, key) => key.indexOf(lang) >= 0);
  const hash = key ? langMap[key] : undefined;
  return hash;
};
